import { Component } from '@angular/core';

@Component({
    selector: 'agpr-social',
    templateUrl: './social.component.html',
    styleUrls: ['./social.component.scss'],
    providers: [],
    standalone: false
})
export class SocialComponent {

    constructor() {

    }
}
